module.exports = __webpack_public_path__ + "static/media/message-promotion-title@2x.da86c217.png";